export default "/images/6312e42974e0ae2c41990af53610d5a5.avif";